var exports = {
  "dL": "GuildHeader.module__headerWrapper___a1l6bH",
  "N1": "GuildHeader.module__headerContainer___a1l6bH",
  "bp": "GuildHeader.module__headerContainerActive___a1l6bH",
  "vf": "GuildHeader.module__headerContainerBanner___a1l6bH",
  "Le": "GuildHeader.module__headerContainerCollapsing___a1l6bH",
  "On": "GuildHeader.module__headerContainerNoBanner___a1l6bH",
  "nL": "GuildHeader.module__bannerClip___a1l6bH",
  "_e": "GuildHeader.module__bannerImage___a1l6bH",
  "Oo": "GuildHeader.module__bannerImageCentered___a1l6bH",
  "iI": "GuildHeader.module__headerGlass___a1l6bH",
  "nY": "GuildHeader.module__bannerGradient___a1l6bH",
  "VW": "GuildHeader.module__headerContent___a1l6bH",
  "KZ": "GuildHeader.module__headerFocusRing___a1l6bH",
  "w$": "GuildHeader.module__verifiedIcon___a1l6bH",
  "Ve": "GuildHeader.module__verifiedIconDefault___a1l6bH" + " " + "GuildHeader.module__verifiedIcon___a1l6bH",
  "J5": "GuildHeader.module__guildName___a1l6bH",
  "K8": "GuildHeader.module__guildNameDefault___a1l6bH" + " " + "GuildHeader.module__guildName___a1l6bH",
  "rr": "GuildHeader.module__guildNameWithBanner___a1l6bH" + " " + "GuildHeader.module__guildName___a1l6bH",
  "Rq": "GuildHeader.module__caretIcon___a1l6bH",
  "Ic": "GuildHeader.module__caretIconDefault___a1l6bH" + " " + "GuildHeader.module__caretIcon___a1l6bH",
  "Tu": "GuildHeader.module__caretIconWithBanner___a1l6bH" + " " + "GuildHeader.module__caretIcon___a1l6bH",
  "xu": "GuildHeader.module__caretIconOpen___a1l6bH",
  "_S": "GuildHeader.module__dotsIcon___a1l6bH",
  "D1": "GuildHeader.module__dotsIconDefault___a1l6bH" + " " + "GuildHeader.module__dotsIcon___a1l6bH",
  "GX": "GuildHeader.module__dotsIconWithBanner___a1l6bH" + " " + "GuildHeader.module__dotsIcon___a1l6bH",
  "bq": "GuildHeader.module__ghostBadge___a1l6bH",
};

module.exports = exports;
